<div class="field-display">
  <span class="field-value">••••••••</span>
</div>
